import { Link } from '@tanstack/react-router'

import { Alert, Button } from '@forto-dev/phoenix-ui-core'
import { Splash } from '@forto-dev/phoenix-ui-core/ship'

import { useLocalisation } from '@/utils/localisation'

export const DefaultNotFoundComponent = () => {
  const { translate } = useLocalisation()

  return (
    <Splash>
      <Alert variant="negative" title={translate('navigation.not_found.title')} />
      <Button asChild>
        <Link to="/">{translate('navigation.not_found.back')}</Link>
      </Button>
    </Splash>
  )
}
